import { useState } from 'react';
import PropTypes from 'prop-types';

import { Button, IconButton, InputAdornment, Stack, TextField } from '@mui/material';
import { MIcon } from '../../../@material-extend';
import { LayoutTemplatePicture } from '../../templates';
import { IconAccessPassword } from '../../../../assets/icons';

const AccessConfirmation = (props) => {
  const { email, errors, isDisconnect, register, setValue, handleSubmit, subtitle } = props;
  const [showPassword, setShowPassword] = useState(false);

  const handleChangeEmail = (event) => {
    setValue('email', event.target.value, { shouldValidate: true });
  };

  const handleChangePwd = (event) => {
    setValue('password', event.target.value, { shouldValidate: true });
  };

  const handleSubmitForm = (event) => {
    event.preventDefault();
    handleSubmit(isDisconnect);
  };

  const handleShowPassword = () => {
    setShowPassword((show) => !show);
  };

  const endAdornment = (
    <InputAdornment position="end">
      <IconButton onClick={handleShowPassword} edge="end">
        <MIcon icon={showPassword ? 'visibility' : 'visibility_off'} filled />
      </IconButton>
    </InputAdornment>
  );

  return (
    <LayoutTemplatePicture
      picture={<IconAccessPassword />}
      subtitle={subtitle || "Un accès manager est requis pour effectuer cette opération"}
    >
      <form autoComplete="new-password" onSubmit={handleSubmitForm} action="">
        <Stack mt={1} gap={3}>
          <TextField
            {...register('email')}
            fullWidth
            type="email"
            defaultValue=""
            name="new-mail-no-autofill"
            id="new-mail-no-autofill"
            label="Adresse e-mail"
            value={email}
            error={Boolean(errors.email)}
            spellCheck="false"
            autoComplete="new-password"
            helperText={errors.email && errors.email.message ? errors.email.message : null}
            onChange={handleChangeEmail}
          />

          <TextField
            {...register('password')}
            defaultValue=""
            fullWidth
            type={showPassword ? 'text' : 'password'}
            id="new-password-no-autofill"
            name="new-password-no-autofill"
            label="Mot de passe"
            spellCheck="false"
            autoComplete="new-password"
            slotProps={{ input: { endAdornment } }}
            error={Boolean(errors.password)}
            helperText={errors.password && errors.password.message ? errors.password.message : null}
            onChange={handleChangePwd}
          />
        </Stack>

        <Button type="submit" className="hidden" />
      </form>
    </LayoutTemplatePicture>
  );
};

AccessConfirmation.propTypes = {
  control: PropTypes.object.isRequired,
  email: PropTypes.string,
  errors: PropTypes.object.isRequired,
  isDisconnect: PropTypes.bool,
  register: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  subtitle: PropTypes.string
};

export default AccessConfirmation;
